import React from "react";
import { Typography, Button, Switch, Badge } from "antd";
import PropTypes from "prop-types";
import { DashboardOutlined, MessageOutlined, BulbOutlined, BulbFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSignalR } from "Common/hooks/context/SingleRContext";
const { Title } = Typography;
const Header = ({ darkMode, setDarkMode }) => {
  const { unreadMessages } = useSignalR();
  const navigate = useNavigate();
  const styles = {
    badgeIcon: {
      fontSize: 20,
      color: darkMode ? "rgba(255, 255, 255, 0.65)" : undefined,
    },
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 24,
      }}
    >
      <Title
        level={2}
        style={{ margin: 0, color: darkMode ? "rgba(255, 255, 255, 0.85)" : "#1a1a1a" }}
      >
        <DashboardOutlined /> Mentor Dashboard
      </Title>
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <Badge count={unreadMessages} size="small" offset={[0, 6]}>
          <Button
            type="text"
            onClick={() => navigate("/messaging")}
            icon={<MessageOutlined style={styles.badgeIcon} />}
            shape="circle"
          />
        </Badge>
        <Switch
          checkedChildren={<BulbFilled />}
          unCheckedChildren={<BulbOutlined />}
          checked={darkMode}
          onChange={() => setDarkMode(!darkMode)}
        />
      </div>
    </div>
  );
};
Header.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  setDarkMode: PropTypes.func.isRequired,
};
export default Header;
